export default [
  {
    path: '/error-404',
    name: 'error-404',
    component: () => { return import('@/views/error/Error404.vue') },
    meta: {
      tabTitle: 'Error',
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => { return import('@/views/pages/authentication/Login.vue') },
    meta: {
      tabTitle: 'Login',
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/nanasmuda567',
    name: 'auth-login-admin',
    component: () => { return import('@/views/pages/authentication/LoginAdmin.vue') },
    meta: {
      tabTitle: 'Login',
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/pages/authentication/login-v1',
    name: 'auth-login-v1',
    component: () => { return import('@/views/pages/authentication/Login-v1.vue') },
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/authentication/login-v2',
    name: 'auth-login-v2',
    component: () => { return import('@/views/pages/authentication/Login-v2.vue') },
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/register',
    name: 'auth-register',
    component: () => { return import('@/views/pages/authentication/Register.vue') },
    meta: {
      tabTitle: 'Register',
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/reset-password/:identifier',
    name: 'auth-reset-password',
    component: () => { return import('@/views/pages/authentication/ResetPassword.vue') },
    meta: {
      tabTitle: 'Reset Password',
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'auth-forgot-password',
    component: () => { return import('@/views/pages/authentication/ForgotPassword.vue') },
    meta: {
      tabTitle: 'Forgot Password',
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/pages/authentication/register-v1',
    name: 'auth-register-v1',
    component: () => { return import('@/views/pages/authentication/Register-v1.vue') },
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/authentication/register-v2',
    name: 'auth-register-v2',
    component: () => { return import('@/views/pages/authentication/Register-v2.vue') },
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/authentication/forgot-password-v1',
    name: 'auth-forgot-password-v1',
    component: () => { return import('@/views/pages/authentication/ForgotPassword-v1.vue') },
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/authentication/forgot-password-v2',
    name: 'auth-forgot-password-v2',
    component: () => { return import('@/views/pages/authentication/ForgotPassword-v2.vue') },
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
  {
    path: '/pages/authentication/reset-password-v1',
    name: 'auth-reset-password-v1',
    component: () => { return import('@/views/pages/authentication/ResetPassword-v1.vue') },
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/authentication/reset-password-v2',
    name: 'auth-reset-password-v2',
    component: () => { return import('@/views/pages/authentication/ResetPassword-v2.vue') },
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/miscellaneous/coming-soon',
    name: 'misc-coming-soon',
    component: () => { return import('@/views/pages/miscellaneous/ComingSoon.vue') },
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/miscellaneous/not-authorized',
    name: 'misc-not-authorized',
    component: () => { return import('@/views/pages/miscellaneous/NotAuthorized.vue') },
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
  {
    path: '/pages/miscellaneous/under-maintenance',
    name: 'misc-under-maintenance',
    component: () => { return import('@/views/pages/miscellaneous/UnderMaintenance.vue') },
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/miscellaneous/error',
    name: 'misc-error',
    component: () => { return import('@/views/pages/miscellaneous/Error.vue') },
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/account-setting',
    name: 'pages-account-setting',
    component: () => { return import('@/views/pages/account-setting/AccountSetting.vue') },
    meta: {
      tabTitle: 'Account Settings',
      pageTitle: 'Account Settings',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Account Settings',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/profile',
    name: 'pages-profile',
    component: () => { return import('@/views/pages/profile/Profile.vue') },
    meta: {
      tabTitle: 'Profile',
      pageTitle: 'Profile',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Profile',
          active: true,
        },
      ],
    },
  },

  {
    path: '/pages/faq',
    name: 'pages-faq',
    component: () => { return import('@/views/pages/faq/Faq.vue') },
    meta: {
      tabTitle: 'FAQ',
      pageTitle: 'FAQ',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'FAQ',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/knowledge-base',
    name: 'pages-knowledge-base',
    component: () => { return import('@/views/pages/Knowledge-base/KnowledgeBase.vue') },
    meta: {
      tabTitle: 'Knowledge Base',
      pageTitle: 'Knowledge Base',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Knowledge Base',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/knowledge-base/:category',
    name: 'pages-knowledge-base-category',
    component: () => { return import('@/views/pages/Knowledge-base/KnowledgeBaseCategory.vue') },
    meta: {
      tabTitle: 'Category',
      pageTitle: 'Category',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Knowledge Base',
          to: '/pages/Knowledge-base',
        },
        {
          text: 'Category',
          active: true,
        },
      ],
      navActiveLink: 'pages-knowledge-base',
    },
  },
  {
    path: '/pages/knowledge-base/:category/:slug',
    name: 'pages-knowledge-base-question',
    component: () => { return import('@/views/pages/Knowledge-base/KnowledgeBaseCategoryQuestion.vue') },
    meta: {
      tabTitle: 'Question',
      pageTitle: 'Question',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Knowledge Base',
          to: '/pages/Knowledge-base',
        },
        {
          text: 'Category',
          to: '/pages/Knowledge-base/category',
        },
        {
          text: 'Question',
          active: true,
        },
      ],
      navActiveLink: 'pages-knowledge-base',
    },
  },
  {
    path: '/pages/pricing',
    name: 'pages-pricing',
    component: () => { return import('@/views/pages/pricing/Pricing.vue') },
  },
  {
    path: '/pages/blog/list',
    name: 'pages-blog-list',
    component: () => { return import('@/views/pages/blog/BlogList.vue') },
    meta: {
      tabTitle: 'Blog List',
      pageTitle: 'Blog List',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Blog',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/blog/:id',
    name: 'pages-blog-detail',
    component: () => { return import('@/views/pages/blog/BlogDetail.vue') },
    meta: {
      tabTitle: 'Blog Detail',
      pageTitle: 'Blog Detail',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Blog',
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/blog/edit/:id',
    name: 'pages-blog-edit',
    component: () => { return import('@/views/pages/blog/BlogEdit.vue') },
    meta: {
      tabTitle: 'Blog Edit',
      pageTitle: 'Blog Edit',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Blog',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: () => { return import('@/views/pages/authentication/PrivacyPolicy.vue') },
    meta: {
      tabTitle: 'Privacy Policy',
      pageTitle: 'Privacy Policy',
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/term-condition',
    name: 'term-condition',
    component: () => { return import('@/views/pages/authentication/TermCondition.vue') },
    meta: {
      tabTitle: 'Terms & Conditions',
      pageTitle: 'Terms & Conditions',
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
]
